import { listPath } from "./constants/insightsPath";
import { dateToTimeStampForList } from "./dateTime/date";

const buildFilters = (path, filterConditions) => {
    let filters = { ...filterConditions };
    // // console.log("filters",filters);
    if (!filters || Object.keys(filters).length === 0) {
        return ({ filters: [] });
    }

    Object.keys(filters).forEach((key) => {
        if (Array.isArray(filters[key])) {
            filters[key] = filters[key][0];
        }
    });
    
    const filterArray = Object.entries(filters).reduce((acc, [key, value]) => {
        if (value) {
            let operator = "EQUALS";
            if (key === "fromDate") {
                if (path === listPath.COMPLAINTS) {
                    key = "createdDate";
                } else if (path === listPath.QRCODE) {
                    key = "created_at";
                } else {
                    key = "createdAtEpocMs";
                }
                operator = "GREATER THAN EQUALS";
                value = (path === listPath.QRCODE) ? value : dateToTimeStampForList(value);
            } else if (key === "toDate") {
                if (path === listPath.COMPLAINTS) {
                    key = "createdDate";
                } else if (path === listPath.QRCODE) {
                    key = "created_at";
                } else {
                    key = "createdAtEpocMs";
                }
                operator = "LESS THAN EQUALS";
                value = (path === listPath.QRCODE) ? value : dateToTimeStampForList(`${value}T23:59:59.999Z`);
            } else if (key === 'category') {
                if (path === listPath.COMPLAINTS) {
                    key = "complaintCategory";
                } else if (path === listPath.QRCODE) {
                    key = "skuId";
                } else {
                    key = "category";
                }
            } else if (key === 'companyId') {
                key = "companyId";
                operator = "EQUALS";
            }
            acc.push({ key, value, operator });
        }
        return acc;
}, []);

    return ({ filters: filterArray });
};

export default buildFilters;